import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PlacementTestForm from '../../features/placement-tests-form/ui/PlacementTestForm';
import {
  getAdminKidsTestTemplateById,
  updateAdminKidsTestTemplate,
} from '../../shared/api/kids-tests.services';
import { KIDS_DIAGNOSTIC_TEST_SLUG } from '../../shared/config/testSlugs';
import { getLocalizedValue } from '../../shared/lib/localization';

const KIDS_TEST_FORM_ID = 'kids-test-form';

// Редактор питань дитячого тесту. Форма спільна з дорослим Placement Test —
// у них однакові типи завдань, — але зберігається вона через ендпоінт
// дитячого тесту, тож дорослий тест звідси змінити неможливо.
const KidsTestsRewritePage = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (templateId) {
      fetchTemplate();
    }
  }, [templateId]);

  const fetchTemplate = async () => {
    setIsLoading(true);
    try {
      const data = await getAdminKidsTestTemplateById(templateId);
      setTemplate(data);
    } catch (err) {
      console.error('Error fetching kids test template:', err);
      setError(err.message || 'Помилка при завантаженні');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="page-wrapper">
        <div className="loading">Завантаження...</div>
      </div>
    );
  }

  if (error && !template) {
    return (
      <div className="page-wrapper">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (!template) {
    return (
      <div className="page-wrapper">
        <div className="error-message">Шаблон не знайдено</div>
      </div>
    );
  }

  return (
    <>
      <section className="section-admin section-form">
        <div className="section-form__header">
          <h2>Редагування дитячого тесту: {getLocalizedValue(template.title, 'ua')}</h2>
          <button onClick={() => navigate('/kids-tests')}>Повернутися</button>
        </div>

        <PlacementTestForm
          initialData={template}
          templateId={templateId}
          formId={KIDS_TEST_FORM_ID}
          fallbackSlug={KIDS_DIAGNOSTIC_TEST_SLUG}
          saveTemplate={updateAdminKidsTestTemplate}
        />
      </section>

      <button form={KIDS_TEST_FORM_ID} className="product-form__submit" type="submit" disabled={isLoading}>
        Зберегти
      </button>
    </>
  );
};

export default KidsTestsRewritePage;
